import styled from 'styled-components';
import { media, Heading } from '@simplywallst/ui-core';
import SWSLogo from '@assets/images/logo/sws-logo-black.svg';

import {
  getCloudflareImageUrl,
  getStaticUrl,
} from '@/hooks/useCloudflareImage';

export const Container = styled('div')`
  height: 100%;
  color: ${({ theme }) => theme.color.darkGray};
  background: url(${getCloudflareImageUrl({
        src: getStaticUrl('/onboarding/background-desktop-2x.png'),
        width: 316,
        height: 302,
      })})
      no-repeat right bottom,
    linear-gradient(
        180deg,
        rgba(35, 148, 223, 0.3) 0%,
        rgba(35, 148, 223, 0.1) 100%
      )
      fixed;

  ${media.mdDown`
    background: url(${getCloudflareImageUrl({
      src: getStaticUrl('/onboarding/background-mobile-2x.png'),
      width: 181,
      height: 229,
    })})
      no-repeat right bottom,
    linear-gradient(
        180deg,
        rgba(35, 148, 223, 0.3) 0%,
        rgba(35, 148, 223, 0.1) 100%
      )
      fixed;
  `}

  @media (max-width: 320px) {
    background: url(''),
      linear-gradient(
          180deg,
          rgba(35, 148, 223, 0.3) 0%,
          rgba(35, 148, 223, 0.1) 100%
        )
        fixed;
  }
`;

export const Content = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${({ theme }) => {
    const a = theme.x4spacePx + 'px';
    return `${a} ${theme.x5spacePx + 'px'} ${theme.x4spacePx + 'px'} ${a}`;
  }};
  ${media.mdDown`
     padding: ${({ theme }) => {
       const a = theme.x3spacePx + 'px';
       return `${a} ${theme.x4spacePx + 'px'} ${theme.x6spacePx + 'px'} ${a}`;
     }};
  `}
`;

export const SectionLogo = styled('div')``;

export const Logo = styled(SWSLogo)`
  width: 100%;
  max-width: 171px;

  ${media.mdDown`
    max-width: 154px;
  `}
`;

export const SectionText = styled('div')`
  flex: 1;
  max-width: 70%;
  ${media.smDown`
     max-width: 100%;
  `}
  h1 {
    ${({ theme }) => theme.typography.xSmallStrong}
    font-size: 21px !important;
    line-height: 27px !important;
    margin-bottom: 6px;
    ${media.mdDown`
      margin-bottom: ${({ theme }) => theme.x1spacePx}px;
      ${({ theme }) => theme.typography.xSmallStrong}
    `}
  }
  p {
    ${({ theme }) => theme.typography.small}
    font-size: 14px;
    ${media.mdUp`
      margin-bottom: 1em;
    `}
    ${media.mdDown`
      max-width: 80%;
    `}
    ${media.smDown`
      max-width: 50%;
    `}
  }
`;

export const HeadingText = styled(Heading)`
  font-weight: 500;
  color: ${({ theme }) => theme.color.charcoal};
`;
